<h2 mat-dialog-title>{{ data.message }}</h2>
<div mat-dialog-content>
  <!-- Puedes personalizar el contenido del cuerpo del cuadro de diálogo según tus necesidades -->
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No</button>
  <button mat-button color="primary" (click)="onYesClick()">Sí</button>
</div>